<div class="month-selector-container">
  <!-- arrow left  -->
  <ion-icon
    name="caret-back-circle"
    (click)="changeMonth(addRemoveEnum.remove)"
    class="icon"
  ></ion-icon>
  <!-- month --><!-- current balence or month balence -->
  <span class="month-year">
    {{ selectedDate | date : "MMMM yyyy" | titlecase }}</span
  >
  <span class="sum-currencies">
    {{
      ratios?.length > 0
        ? (ratios[0].amount | currency : ratios[0].currency)
        : "Pas de données"
    }}
  </span>
  <!-- arrow right (disabled if current month of current year) -->
  <ion-icon
    name="caret-forward-circle"
    (click)="changeMonth(addRemoveEnum.add)"
    class="icon"
  ></ion-icon>
</div>
